import { useState } from 'react';
import intl from 'react-intl-universal';
import { Button } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { userNameColumn, userIDColumn } from './CommonColumns';
import PropTypes from 'prop-types';
import logger from 'utils/logger';

const log = logger.createLogger('SearchColumns');

const searchOperationColumn = (sendApplication) => {
  return {
    accessorKey: 'operation',
    header: intl.get('friends_label_column_operations'),
    enableColumnFilter: false,
    enableColumnActions: false,
    enableSorting: false,
    Cell: ({ renderedCellValue }) => (
      <SearchOperationCell
        renderedCellValue={renderedCellValue}
        sendApplication={sendApplication}
      />
    ),
  };
};

const SearchOperationCell = ({ renderedCellValue, sendApplication }) => {
  const [hasBeenSent, setHasBeenSent] = useState(false);

  const value = renderedCellValue;
  const userID = value.userId;
  const isSent = value.isSent;

  const handleClick = () => {
    if (!hasBeenSent && !isSent) {
      setHasBeenSent(true);
      sendApplication(userID);
    }
  };

  return (
    <Grid container spacing={1}>
      <Button
        variant="contained"
        color="primary"
        disabled={hasBeenSent || isSent}
        onClick={handleClick}>
        {isSent
          ? intl.get('friends_button_in_application')
          : intl.get('friends_button_add_friend')}
      </Button>
    </Grid>
  );
};

SearchOperationCell.propTypes = {
  renderedCellValue: PropTypes.shape({
    userId: PropTypes.string.isRequired,
    isSent: PropTypes.bool.isRequired,
  }).isRequired,
  sendApplication: PropTypes.func.isRequired,
};

export const searchColumns = (sendApplication) => [
  userNameColumn(),
  userIDColumn(),
  searchOperationColumn(sendApplication),
];
